import { useEffect } from "react";
import UseGql from "@/services/graph-ql/useGql";
import GraphTable from "./graph-table";
import { Box } from "@mui/material";
import CardWidget from "@/components/card-widget";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

const WidgetGraphWrapper = ({
  value = 0,
  query,
  dataKey = "",
  paramKey = "createdOn",
  loading = false,
  columns = [],
  data = {},
  secondDataKey = "",
  unit = "",
}) => {
  // const [data, setData] = useState([]);
  const { executeQuery, loading: loader } = UseGql(
    query,
    { variables: {} },
    "report",
    {},
    true
  );

  useEffect(() => {
    // fetchData();
  }, []);

  const makeParams = (obj = {}) => {
    return {
      where: {
        and: [
          { [paramKey]: { gte: obj?.gte } },
          { [paramKey]: { lte: obj?.lte } },
        ],
      },
    };
  };
  const fetchData = (key) => {
    executeQuery({ skip: 0, take: 100 }).then((res) => {
      const { data } = res;
      if (data && data?.[dataKey]) {
        setData(data?.[dataKey]?.items);
      }
    });
  };

  const isInboundCallsReport = dataKey === "inboundCallReport";

  const inboundSummary = (() => {
    if (!isInboundCallsReport) return null;
    const items = data?.items || [];
    return items.reduce(
      (acc, item) => ({
        totalAnswered: acc.totalAnswered + (item.answered || 0),
        totalAbandoned: acc.totalAbandoned + (item.abandoned || 0),
        grandTotal: acc.grandTotal + (item.total || 0),
      }),
      { totalAnswered: 0, totalAbandoned: 0, grandTotal: 0 }
    );
  })();

  const renderHeader = isInboundCallsReport
    ? () => {
        const cards = [
          {
            label: "Total Inbound Calls",
            key: "grandTotal",
            color: "blue",
            icon: faPhone,
          },
          {
            label: "Answered Calls",
            key: "totalAnswered",
            color: "green",
            icon: faPhone,
          },
          {
            label: "Abandoned Calls",
            key: "totalAbandoned",
            color: "orange",
            icon: faPhone,
            iconStyles: {
              transform: "rotate(135deg)",
              transformOrigin: "center",
            },
          },
        ];

        return (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(290px,1fr))",
              gap: 1.2,
              mb: 2,
            }}
          >
            {cards.map((card) => (
              <CardWidget
                key={card.key}
                title={card.label}
                color={card.color}
                Icon={card.icon}
                materialIcon={!!card.materialIcon}
                currentValue={inboundSummary ? inboundSummary[card.key] : 0}
                previousValue={0}
                filter={{ id: 7, title: "Today" }}
                onFilterChange={() => {}}
                iconStyles={card.iconStyles}
                loading={loading}
                isDashboardWidget={false}
                hideFilter={true}
              />
            ))}
          </Box>
        );
      }
    : undefined;

  return (
    <GraphTable
      data={secondDataKey ? data?.items?.[secondDataKey] : data?.items || []}
      columns={columns}
      value={value}
      loading={loading}
      renderHeader={renderHeader}
      unit={unit}
    />
  );
};

export default WidgetGraphWrapper;
